import { onDomReady } from './events';

let onOk;
let onCancel;

window.confirmationModal = {
  ask(message, callbackOnOk, callbackOnCancel, okText, cancelText) {
    getOkButton().innerText = okText || 'OK';
    getCancelButton().innerText = cancelText || 'Cancel';
    setContent(message);
    if (typeof callbackOnOk !== 'undefined') {
      setOnOk(callbackOnOk);
    }
    if (typeof callbackOnCancel !== 'undefined') {
      setOnCancel(callbackOnCancel);
    }
    showCancelButton();
    show();
  },
  tell(message) {
    setContent(message);
    hideCancelButton();
    show();
  },
  // Call with await to block execution till user clicks OK
  async tellBlocking(message) {
    setContent(message);
    hideCancelButton();
    show();
    await getPromiseFromEvent(getOkButton(), 'click');
  },
}

// lifted from https://stackoverflow.com/a/70789108
function getPromiseFromEvent(item, event) {
  return new Promise((resolve) => {
    const listener = () => {
      item.removeEventListener(event, listener);
      resolve();
    }
    item.addEventListener(event, listener);
  })
}

onDomReady(() => {
  getOkButton().addEventListener('click', (event) => {
    hide();
    onOk(event);
    reset();
  });

  getCancelButton().addEventListener('click', (event) => {
    hide();
    onCancel(event);
    reset();
  });

  reset();
});

function reset() {
  setOnOk(() => {});
  setOnCancel(() => {});
}

function setContent(text) {
  const wrapper = getMessageWrapper();
  while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);
  text.split(/\n|\r\n/).forEach(passage =>  {
    if (passage.length === 0) return;
    const paragraph = document.createElement('p');
    paragraph.innerText = passage;
    wrapper.appendChild(paragraph);
  });
}

function setOnOk(handler) {
  onOk = handler;
}

function setOnCancel(handler) {
  onCancel = handler;
}

function show() {
  showElement(getModal());
  getOkButton().focus();
}

function hide() {
  hideElement(getModal());
  getOkButton().blur();
  getCancelButton().blur();
}

function showCancelButton() {
  const element = getCancelButton();
  showElement(element);
}

function hideCancelButton() {
  const element = getCancelButton();
  hideElement(element);
}

function showElement(element) {
  element.classList.remove('hidden');
}

function hideElement(element) {
  element.classList.add('hidden');
}

function getModal() {
  return document.getElementById('confirmation-modal');
}

function getMessageWrapper() {
  return document.getElementById('confirmation-modal-message');
}

function getOkButton() {
  return document.getElementById('confirmation-modal-ok');
}

function getCancelButton() {
  return document.getElementById('confirmation-modal-cancel');
}
